import React, { PureComponent } from 'react'
import { SelectMenu, Autocomplete, Pane, Text, Dialog, TextInput, toaster, Spinner } from 'evergreen-ui'
import { CheckCircleTwoTone } from '@ant-design/icons'
import { Button, Switch } from "antd";
import { ButtonBase } from '@material-ui/core'
import momentTZ from 'moment-timezone'

import modelDict from '../../utils/cameraModels'
import { Camera } from '../../types';
import Datafetcher from '../../utils/datafetcher';


interface Props{
    cameras: Camera[]
    datafetcher: Datafetcher
    newCameraModalShow: boolean
    setNewCameraModal: (a : boolean) => void
    refreshInfo: () => void
}

interface State{
    selectedBrand: React.ReactText | null
    selectedModel: React.ReactText | null
    cameraTypedUser: string
    cameraTypedPassword: string
    cameraTypedIP: string
    newCameraUrl: string | undefined
    newCameraNickname: string | undefined
    timeZone: any

    manualEntry: boolean
    newCameraModalShow: boolean
    addingCamera: boolean
}

export default class NewCamera extends PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            selectedBrand: null,
            selectedModel: null,
            cameraTypedUser: "",
            cameraTypedPassword: "",
            cameraTypedIP: "",
            newCameraUrl: undefined,
            newCameraNickname: undefined,
            timeZone: momentTZ.tz.guess(),
            manualEntry: false,
            newCameraModalShow: false,
            addingCamera: false
        }
    }

    componentDidUpdate(oldProps: Props) {
        if (this.props === oldProps) { return }
        this.setState({ newCameraModalShow: this.props.newCameraModalShow })
    }

    generateRTSP = () => {
        const { selectedBrand, selectedModel, cameraTypedUser, cameraTypedPassword, cameraTypedIP } = this.state;

        let ctU = cameraTypedUser
        let ctP = cameraTypedPassword
        if (!ctU) {
            ctU = ""
        }
        if (!ctP) {
            ctP = ""
        }

        if(!selectedBrand || !selectedModel){return ""}

        return modelDict[selectedBrand][selectedModel][0]
            .replace("{{stream}}", "0")
            .replace("{{username}}", ctU)
            .replace("{{password}}", ctP)
            .replace("{{ip_address}}", cameraTypedIP)
            .replace("{{port}}", modelDict[selectedBrand][selectedModel][1])
    }

    getModels = (mD: typeof modelDict, make : string) => {
        return mD[make]
    } 

    addCamera = (url: string) => {
        const { cameras, datafetcher, setNewCameraModal, refreshInfo } = this.props;
        const { newCameraUrl, newCameraNickname, timeZone } = this.state;

        this.setState({ addingCamera: true })

        let cl;
        if (cameras) { cl = cameras.length } else { cl = 0 }
        if (!newCameraNickname || !timeZone) {
            toaster.notify('Please enter a nickname and the timezone for the camera.')
            this.setState({ addingCamera: false })
            return
        }

        for (let i = 0; i < cl; i++) {
            if (cameras[i].id === newCameraUrl) {
                toaster.notify('A camera with this URL is already registered in your account.')
                this.setState({ addingCamera: false })
                return
            }
        }

        datafetcher.addNewCamera(newCameraNickname, url, timeZone, (err, _) => {
            this.setState({ addingCamera: false })
            if (err) {
                toaster.notify('Something went wrong. Please verify your information.')
                return
            }
            this.setState({
                addingCamera: false,
                newCameraModalShow: false,
                newCameraNickname: undefined,
                newCameraUrl: undefined,
            })
            toaster.notify('New camera successfully added.')
            refreshInfo()
            setNewCameraModal(false)
        })

    }

    addNewCameraForm = () => {
        const { selectedBrand, selectedModel } = this.state;
        if (!selectedBrand || !selectedModel) { 
            toaster.notify('Please select your camera\'s brand and model'); 
            return
        }
        this.addCamera(this.generateRTSP())
    }

    addNewCamera = () => {
        const { newCameraUrl } = this.state;
        if (newCameraUrl) {
            this.addCamera(newCameraUrl)
        }
    }

    render() {
        const { addingCamera, newCameraNickname, manualEntry, newCameraUrl, selectedBrand,
            selectedModel, cameraTypedIP, cameraTypedUser, cameraTypedPassword } = this.state;
        const { setNewCameraModal } = this.props;

        return (
            <Dialog
                isShown={this.state.newCameraModalShow}
                title="New camera"
                hasFooter={false}
                shouldCloseOnOverlayClick={false}
                onCloseComplete={() => setNewCameraModal(false)}
                confirmLabel="Add camera"
                width={400}>
                <Pane
                    display="flex"
                    alignItems="center"
                    flexDirection="column">
                    {
                        addingCamera ? <Spinner marginTop={75} marginBottom={75} /> : <>
                            <TextInput id="step2" marginTop={0} name="new-camera-nickname" placeholder="Nickname" value={newCameraNickname}
                                onChange={(e: any) => this.setState({ newCameraNickname: e.target.value })} />
                            <Pane
                                display="flex"
                                alignItems="left"
                                flexDirection="row"
                                marginTop={15}
                                marginBottom={15}>
                                <Autocomplete
                                    title="Timezone"
                                    onChange={changedItem => this.setState({ timeZone: changedItem })}
                                    items={momentTZ.tz.names()}
                                    defaultSelectedItem={momentTZ.tz.guess()}
                                    children={(props) => {
                                        const { getInputProps, getRef, openMenu } = props
                                        return <TextInput 
                                            placeholder="Timezone"

                                            innerRef={getRef}
                                            {...getInputProps({ onFocus: () => { openMenu() } })} />
                                    }}
                                />
                            </Pane>
                            <Pane display="flex" justifyContent="space-between">
                                <Switch checked={manualEntry} onChange={(checked) => { this.setState({ manualEntry: checked }) }} />
                                <Text marginTop={2.5} marginLeft={10}>Manual RTSP or MJPEG link</Text>
                            </Pane>
                            {
                                manualEntry ?
                                    <>
                                        <TextInput
                                            marginTop={10}
                                            placeholder="Manually enter camera RTSP/MJPEG link"
                                            autocomplete="off"
                                            value={newCameraUrl}
                                            onChange={(e:any) => this.setState({ newCameraUrl: e.target.value })}
                                        >

                                        </TextInput>
                                        <Button shape="round" style={{ marginTop: 15 }} id="step6" onClick={this.addNewCamera}>
                                            <CheckCircleTwoTone />
                                        </Button>
                                    </> :
                                    <Pane
                                        display="flex"
                                        alignItems="center"
                                        flexDirection="column"
                                        padding={15}
                                        borderRadius={5}
                                    >
                                        <Pane
                                            display="flex"
                                            alignItems="left"
                                            flexDirection="row"
                                        >
                                            <SelectMenu
                                                title="DVR/Camera brand"
                                                options={Object.keys(modelDict).map(label => ({ label, value: label }))}
                                                selected={typeof selectedBrand === 'string' ? selectedBrand : ""}
                                                closeOnSelect={true}
                                                onSelect={item => this.setState({
                                                    selectedBrand: item.value,
                                                    selectedModel: null,
                                                })}>
                                                <ButtonBase style={{ border: "1px solid #87CEEB", padding: 5, borderRadius: 3 }}>
                                                    {selectedBrand || 'DVR/Camera Brand'}
                                                </ButtonBase>
                                            </SelectMenu>
                                        </Pane>
                                        {selectedBrand ? <Pane
                                            display="flex"
                                            alignItems="left"
                                            flexDirection="row"
                                            marginTop={15}>
                                            <SelectMenu
                                                title="Model or Type"
                                                options={Object.keys(modelDict[selectedBrand]).map(label => ({ label, value: label }))}
                                                selected={typeof selectedModel === 'string' ? selectedModel : ""}
                                                closeOnSelect={true}
                                                onSelect={item => this.setState({ selectedModel: item.value })}>
                                                <ButtonBase style={{ border: "1px solid #87CEEB", padding: 5, borderRadius: 3 }}>{selectedModel || 'Model or Type'}</ButtonBase>
                                            </SelectMenu>
                                        </Pane> : <></>}

                                        <div style={{ "overflow": "hidden", "height": "0px", "background": "transparent" }} data-description="dummyPanel for Chrome auto-fill issue">
                                            <input type="text" style={{ "overflow": "hidden", "height": "0px", "background": "transparent" }} data-description="dummyUsername"></input>
                                            <input type="password" style={{ "overflow": "hidden", "height": "0px", "background": "transparent" }} data-description="dummyPassword"></input>
                                        </div>

                                        <TextInput marginTop={15} placeholder="IP Address or Camera URL" value={cameraTypedIP} onChange={(e:any) => this.setState({ cameraTypedIP: e.target.value })} />
                                        <TextInput autocomplete="off" marginTop={15} placeholder="Camera Username" value={cameraTypedUser} onChange={(e: any) => this.setState({ cameraTypedUser: e.target.value })} />
                                        <TextInput autocomplete="new-password" marginTop={15} placeholder="Camera Password" type="password" value={cameraTypedPassword} onChange={(e: any) => this.setState({ cameraTypedPassword: e.target.value })} />
                                        <Button shape="round" style={{ marginTop: 15 }} id="step6" onClick={() => { this.addNewCameraForm(); }}><CheckCircleTwoTone /></Button>

                                        {(selectedBrand && selectedModel && cameraTypedIP && cameraTypedUser && cameraTypedPassword) ?
                                            <TextInput
                                                marginTop={15}
                                                placeholder="RTSP generated link"
                                                autocomplete="off"
                                                value={(selectedBrand && selectedModel && cameraTypedIP && cameraTypedUser && cameraTypedPassword) ? this.generateRTSP() : ""}
                                                onChange={(e: any) => this.setState({ newCameraUrl: e.target.value })}
                                            ></TextInput> : <></>}
                                    </Pane>
                            }
                        </>
                    }
                </Pane>
            </Dialog>
        )
    }

}


/* <Pane
    display="flex"
    alignItems="center"
    flexDirection="row"
    marginBottom={10}
    marginTop={10}>
    {['a', 'b'].map((tab, index) => (
    <Tab
        key={tab}
        id={tab}
        elevation={1}
        onSelect={() => this.setState({ selectedIndex: index })}
        isSelected={index === this.state.selectedIndex}
        aria-controls={`panel-${tab}`}>
        {buttonsDict[tab]}
    </Tab>
    ))}
</Pane> */

/* {this.state.selectedIndex === 1 ?
<Pane
    display="flex"
    alignItems="center"
    flexDirection="column"
    marginTop={10}
    marginBottom={10}>
    <TextInput placeholder="Webhook https address" value={this.state.webhook} onChange={e => this.setState({ webhook: e.target.value })} />
</Pane> : <></>
} */


        // if (this.props.user && !this.props.user.paymentSaved) {
        //   toaster.notify('First you need to link your credit card.')
        //   this.setState({
        //     addingCamera: false,
        //     showStripe: true,
        //     newCameraModalShow: false
        //   })
        //   return
        // }